import React from "react";
import {
  AdminSectionTitle,
  AdminMainText,
  AdminSupportingText,
  AdminMetadataText,
} from "../../../AdminDashboard/shared/adminUx";

const NotificationsLayout = () => {
  const Notificationdata = [
    {
      heading: "Account & Security",
      description: "Login alerts, password changes, security notices",
      emailEnabled: true,
      smsEnabled: true,
      pushEnabled: false,
    },
    {
      heading: "Profile Changes",
      description: "Notifications when profile details are updated",
      emailEnabled: false,
      smsEnabled: true,
      pushEnabled: true,
    },
    {
      heading: "Customer Messages",
      description: "New messages from customers",
      emailEnabled: true,
      smsEnabled: false,
      pushEnabled: true,
    },
    {
      heading: "Customer Reviews",
      description: "Alerts for new customer reviews",
      emailEnabled: false,
      smsEnabled: false,
      pushEnabled: true,
    },
    {
      heading: "Billing & Subscription Reminders",
      description: "Payment and renewal alerts",
      emailEnabled: true,
      smsEnabled: true,
      pushEnabled: false,
      emailLocked: true,
      specialNote: "Email must always stay On. SMS optional.",
    },
    {
      heading: "Compliance Notices",
      description: "Legal or regulatory changes",
      emailEnabled: true,
      smsEnabled: true,
      pushEnabled: true,
    },
    {
      heading: "Platform Announcements",
      description: "Policy updates and system news",
      emailEnabled: false,
      smsEnabled: true,
      pushEnabled: false,
    },
    {
      heading: "Data Privacy Updates",
      description: "Changes to privacy rules or consent requirements",
      emailEnabled: true,
      smsEnabled: false,
      pushEnabled: true,
    },
  ];

  return (
    <div className="lg:mx-auto w-[768px]">
      {Notificationdata.map((item, index) => (
        <div
          key={item.heading}
          className="flex justify-between gap-x-5 mb-4 bg-mistygray border border-mistygray rounded-xl p-4"
        >
          <div className="flex-1">
            <AdminSectionTitle className="text-offblack">{item.heading}</AdminSectionTitle>
            <AdminMainText className="mt-2 text-offblack block">{item.description}</AdminMainText>

            <div className="flex flex-wrap gap-6 mt-3">
              {[
                { id: "email", label: item.emailLocked ? "Email (locked On)" : "Email", checked: item.emailEnabled, locked: item.emailLocked },
                { id: "sms", label: "SMS", checked: item.smsEnabled },
                { id: "push", label: "Push", checked: item.pushEnabled },
              ].map((opt) => (
                <label key={opt.id} className="flex items-center gap-2 cursor-pointer">
                  <input
                    type="checkbox"
                    defaultChecked={opt.checked}
                    disabled={opt.locked}
                    className="size-4 rounded border-mediumgray text-primaryblue focus:ring-primaryblue disabled:opacity-60"
                  />
                  <AdminMetadataText className={opt.locked ? "text-mediumgray" : "text-offblack"}>
                    {opt.label}
                  </AdminMetadataText>
                </label>
              ))}
            </div>

            {item.specialNote ? (
              <AdminSupportingText className="mt-2 text-mediumgray block">
                {item.specialNote}
              </AdminSupportingText>
            ) : null}
          </div>
          <label className="relative inline-flex items-center cursor-pointer flex-shrink-0">
            <input type="checkbox" className="sr-only peer" defaultChecked />
            <div className="w-9 h-5 bg-lightgray rounded-full peer-checked:after:translate-x-full after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-lightgray after:border after:rounded-full after:h-4 after:w-4 after:transition-all peer-checked:bg-primaryblue" />
          </label>
        </div>
      ))}
    </div>
  );
};

export default NotificationsLayout;
